import React from "react";

import { Table } from "antd";

import DSButton from "../../../components/DSButton";
import { usePermissions } from "../../../Context/permissionContext";
import { getFormatDateAndTimeNoTz } from "../../../utils/formatDate";
import * as S from "../style";

function UsersTable({ data, handleOpenModal }) {
  const { permissions } = usePermissions();

  const columns = [
    {
      title: "NSU Origem",
      dataIndex: "nsuOrigem",
    },
    {
      title: "Data de Criação",
      dataIndex: "dataCriacao",
      render: (valor) => {
        return getFormatDateAndTimeNoTz(valor);
      },
    },
    {
      title: "Data de Expiração",
      dataIndex: "dataExpiracao",
      render: (valor) => {
        return getFormatDateAndTimeNoTz(valor);
      },
    },

    {
      title: "Data de Utilizacao",
      dataIndex: "dataUtilizacao",
    },
    {
      title: "Valor",
      dataIndex: "valor",
      render: (valor) => {
          return valor.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          });
      },
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Cancelar Reserva",
      dataIndex: "nsuOrigem",
      align: "center",
      render: (nsuOrigem) => (
        <>
          {permissions.includes("cancel_reserve_balance") && (
            <DSButton
              type="button"
              buttonType="secondary"
              isCancelType
              buttonText="Cancelar Reserva"
              onClick={() => handleOpenModal(nsuOrigem)}
              height={30}
              style={{ padding: "0.4rem 1.5rem" }}
              dataTestId={`btn-cancelar-reserva-${nsuOrigem}`}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <>
    <S.TableContainer>
      <Table
        className="tableListsadjustment not-global"
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 5 }} />
    </S.TableContainer>

    </>
  );
}

export default React.memo(UsersTable);
